<mat-card-header>
  <div style="width:90%">
    <mat-card-title>
      <label class="mat-h2 bold">Deseja salvar esse protocolo? </label>
    </mat-card-title>
  </div>
  <div style="width:10%; cursor:pointer;">
    <mat-icon class="btnCancel" style="position: relative; float: right; margin-right: 5px" (click)="closePopup()">cancel</mat-icon>
  </div>

</mat-card-header>
<mat-card-content style="width: 500px">
  <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="15%">
    <label class="mat-h4 bold">Documento </label>
    <label class="mat-h4">{{data.descTipoDocumento}}</label>
  </div>
  <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="11%">
    <label class="mat-h4 bold">Empresa MRV </label>
    <label class="mat-h4">{{data.nomeEmpresa}}</label>
  </div>
  <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="15%">
    <label class="mat-h4 bold">Fornecedor </label>
    <label class="mat-h4">{{data.nomeFornecedor}}</label>
  </div>
  <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="19%">
    <label class="mat-h4 bold">Emissão </label>
    <label class="mat-h4">{{data.dataEmissaoNf.toLocaleDateString()}}</label>
  </div>
  <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="14%">
    <label class="mat-h4 bold">Vencimento </label>
    <label class="mat-h4">{{data.dataVencimentoNf?.toLocaleDateString()}} </label>
  </div>
  <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="23%">
    <label class="mat-h4 bold">Valor </label>
    <label class="mat-h4">{{data.valor | currency:'BRL':true}}</label>
  </div>

</mat-card-content>
<div *ngIf="data.idProtocolo != 0">
  <div style="width:90%">
    <mat-card-title>
      <label class="mat-h2 bold" style="color:red">Atenção </label>
    </mat-card-title>
  </div>
  <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="15%" style="margin-bottom: 20px;">
    <label class="bold" style="font-size: 14px;">Toda vez que um protocolo é alterado um novo número de DOCUMENTO é gerado.</label>
  </div>
</div>
<mat-action-row class="footer">
  <button id="btnTipoDoc" mat-button color="primary" class="btn-primary" (click)="confirm()">CONFIRMAR</button>
</mat-action-row>